// extracted by mini-css-extract-plugin
export default {"container":"cEmW84","name":"MAC1dD","model":"i5W_7_","wait-time":"l6lW0Y","compact":"G8ghBE"};